/**
 * sifreBelirleService.js — Şifre belirleme sayfasının herkese açık uçları (backlog #556, backend #555).
 *
 * Eski PHP'nin `/Login/emailactivation/<anahtar>` sayfasının Java karşılığı: bağlantıyı elinde tutan, o girişin şifresini bir kez
 * belirler. Uçlar `/public/sifre` altında (`/api/v1`'in DIŞINDA, oturum istemez); anahtar GET'te `?anahtar=`, POST'ta gövdede gider.
 * Hata gövdesi `{ error, errorKey }` (PublicTadilatController ile aynı): `error` isteğin dilindeki metin, `errorKey` Mesaj anahtarı.
 *   · 404 `sifre.linki_gecersiz` — anahtar bilinmiyor ya da kullanılmış
 *   · 410 `sifre.linki_suresi_doldu` — süresi dolmuş (7 gün)
 *   · 400 `sifre.linki_sifre_kisa` — şifre 8 karakterden kısa; bağlantı çalışmaya devam eder
 * Anahtar yalnızca adres çubuğunda yaşar: ne saklanır ne konsola yazılır.
 *
 * Personelin bağlantıyı OLUŞTURDUĞU uç (POST /users/{id}/sifre-linki) oturum ister, o yüzden userService'te (`createSifreLinki`).
 */
import axios from 'axios';
import { JAVA_BACKEND_ORIGIN, getPublicHeader } from '../Components/Contexts/BackendConstants';

const PUBLIC_BASE = `${JAVA_BACKEND_ORIGIN}/public/sifre`;

/** Backend'in en az şifre uzunluğu (SifreLinkiService.EN_AZ_SIFRE); sayfa aynı sınırı önceden denetler. */
export const EN_AZ_SIFRE = 8;

/** Personelin kopyalayıp ilettiği tam adres: `<köken>/sifre-belirle?anahtar=<anahtar>`. */
export function sifreBelirleAdresi(anahtar) {
  return `${window.location.origin}/sifre-belirle?anahtar=${encodeURIComponent(anahtar)}`;
}

function parseError(error) {
  const data = error.response?.data;
  const govde = data && typeof data === 'object' ? data : {};
  const wrapped = new Error(govde.error || error.message || 'Bilinmeyen hata');
  wrapped.status = error.response?.status ?? null;
  wrapped.errorKey = govde.errorKey || null;
  throw wrapped;
}

/** GET /public/sifre?anahtar= → `{ kullaniciAdi, gecerlilikBitis }`: kimin şifresinin belirleneceği. */
export async function getSifreLinkiBilgisi(anahtar) {
  try {
    const response = await axios.get(PUBLIC_BASE, { params: { anahtar }, headers: getPublicHeader() });
    return response.data;
  } catch (error) {
    parseError(error);
  }
}

/** POST /public/sifre `{ anahtar, sifre }` → `{ kullaniciAdi, mesaj }`; bağlantı bu çağrıyla kullanılmış olur. */
export async function sifreBelirle(anahtar, sifre) {
  try {
    const response = await axios.post(PUBLIC_BASE, { anahtar, sifre }, { headers: getPublicHeader() });
    return response.data;
  } catch (error) {
    parseError(error);
  }
}
